// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/**
 * Sprint 62.58.0 gate E12.5 pass 1 remainder — a vendor questionnaire
 * instance's status, in the reader's language.
 *
 * One map (`vendor_risk.questionnaires.instance_statuses`) and one reader, used
 * by the Questionnaires list page (badge, screen-reader text and status
 * filter), the onboarding case's linked questionnaires, the risk portfolio's
 * outstanding list, and both exports (`exportInstance`, `exportInstanceList`)
 * (R-43). The surfaces used to read `common_statuses`, which has no
 * `submitted` or `under_review`, so those two printed as raw enum values on
 * every surface; the per-instance export kept its own two keys for them.
 *
 * A value the map does not hold is printed as stored rather than dropped; an
 * absent status is the empty string. Takes the translation object (`t`, or
 * `getTranslations(locale)` on the server) by the one path it reads, so this
 * module does not import the locale bundles.
 */
export function questionnaireInstanceStatusLabel(status, t) {
    if (!status)
        return '';
    const label = t.vendor_risk.questionnaires.instance_statuses[status];
    return typeof label === 'string' ? label : status;
}
/**
 * Sprint 62.58.0 gate E12.5 pass 1 remainder — a questionnaire template's
 * category (its trigger: `initial_onboarding`, `annual_review`,
 * `incident_triggered`, `contract_renewal`), in the reader's language, from the
 * existing `vendor_risk.questionnaires.category_*` labels.
 *
 * Read by the Questionnaires page (the template table's category cell, the
 * new-template form's category options and the reviewer-required message) and
 * the portfolio export's Trigger column (R-43). The page read the category
 * through `common_statuses`, which holds no category, so it printed the raw
 * value. A category without a label is printed as stored; an absent one is the
 * empty string.
 */
export function questionnaireCategoryLabel(category, t) {
    if (!category)
        return '';
    const label = t.vendor_risk.questionnaires[`category_${category}`];
    return typeof label === 'string' ? label : category;
}
//# sourceMappingURL=questionnaire-instance-status.js.map